var map = {
	"./blog.yml": 96,
	"./cloud.yml": 97,
	"./color.yml": 98,
	"./country.yml": 99,
	"./dio.yml": 100,
	"./doc.yml": 101,
	"./emoji.yml": 102,
	"./git.yml": 103,
	"./icon.yml": 104,
	"./license.yml": 105,
	"./link.yml": 106,
	"./metrics.yml": 107,
	"./people.yml": 108,
	"./soft.yml": 109,
	"./src.yml": 110,
	"./status.yml": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;